import { render } from "./director-tab.vue?vue&type=template&id=f8a6e84e&ts=true"
import script from "./director-tab.vue?vue&type=script&lang=ts"
export * from "./director-tab.vue?vue&type=script&lang=ts"

import "./director-tab.vue?vue&type=style&index=0&id=f8a6e84e&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__